<template>
  <div class="input-filed--container">
    <!-- 不明項目存在時の注意書き -->
    <!--<div>{{ $t("bloodTestResult.topHelp") }}</div>-->

    <heading :title="$t('bloodTestResult.glucoseTitle')" class="heading" />
    <!-- 空腹時血糖値 -->
    <input-num
      v-model.number="BLDS"
      :title="$t('bloodTestResult.fastingBloodSugarLevel')"
      unit="mg/dl"
      v-validate="'required|between:0.0,1000.0'"
      name="blds"
      :class="{ invalid: errors.has('blds') }"
      data-vv-as="空腹時血糖値"
    />
    <div class="invalid" v-show="errors.has('blds')">
      {{ errors.first("blds") }}
    </div>

    <!-- HbA1c -->
    <input-num
      v-model.number="HBA1C"
      title="HbA1c(任意)"
      unit="%"
      name="HbA1c"
      min="0.0"
      max="100.0"
      v-validate="'between: 0.0, 100.0'"
      data-vv-as="HbA1c"
    />
    <div class="invalid" v-show="errors.has('HbA1c')">
      {{ $t("validation.between") }}
    </div>

    <heading :title="$t('bloodTestResult.lipidTitle')" class="heading" />
    <!-- 総コレステロール -->
    <input-num
      v-model.number="TOT_CHOLE"
      :title="$t('bloodTestResult.totalCholesterol')"
      unit="mg/dl"
      v-validate="'required|between:0.0,1000.0'"
      name="tot-chole"
      :class="{ invalid: errors.has('tot-chole') }"
      data-vv-as="総コレステロール"
    />
    <div class="invalid" v-show="errors.has('tot-chole')">
      {{ errors.first("tot-chole") }}
    </div>
    <!-- 中性脂肪 -->
    <input-num
      v-model.number="TRIGLYCERIDE"
      :title="$t('bloodTestResult.triglyceride')"
      unit="mg/dl"
      v-validate="'required|between:0.0,1000.0'"
      name="triglyceride"
      :class="{ invalid: errors.has('triglyceride') }"
      data-vv-as="中性脂肪"
    />
    <div class="invalid" v-show="errors.has('triglyceride')">
      {{ errors.first("triglyceride") }}
    </div>
    <!-- HDL -->
    <input-num
      v-model.number="HDL_CHOLE"
      :title="$t('bloodTestResult.hdlcholesterol')"
      unit="mg/dl"
      v-validate="'required|between:0.0,1000.0'"
      name="hdl-chole"
      :class="{ invalid: errors.has('hdl-chole') }"
      data-vv-as="HDL-コレステロール"
    />
    <div class="invalid" v-show="errors.has('hdl-chole')">
      {{ errors.first("hdl-chole") }}
    </div>
    <!-- LDL -->
    <input-num
      v-model.number="LDL_CHOLE"
      :title="$t('bloodTestResult.ldlCholesterol')"
      unit="mg/dl"
      v-validate="'required|between:0.0,1000.0'"
      name="ldl-chole"
      :class="{ invalid: errors.has('ldl-chole') }"
      data-vv-as="LDL-コレステロール"
    />
    <div class="invalid" v-show="errors.has('ldl-chole')">
      {{ errors.first("ldl-chole") }}
    </div>

    <heading :title="$t('bloodTestResult.bloodTitle')" class="heading" />
    <!-- ヘモグロビン -->
    <input-num
      v-model.number="HMG"
      :title="$t('bloodTestResult.hemoglobin')"
      unit="g/dl"
      v-validate="'required|between:0.0,25.0'"
      name="hmg"
      :class="{ invalid: errors.has('hmg') }"
      data-vv-as="ヘモグロビン"
    />
    <div class="invalid" v-show="errors.has('hmg')">
      {{ errors.first("hmg") }}
    </div>
    <!-- 白血球数 -->
    <input-num
      v-model.number="WHITE_BLC"
      :title="`${$t('bloodTestResult.whiteBloodCells')}(任意)`"
      unit="/μL"
      name="whiteBloodCells"
      min="0"
      max="99999"
      v-validate="'between: 0, 99999'"
    />
    <div class="invalid" v-show="errors.has('whiteBloodCells')">
      {{ $t("validation.between") }}
    </div>
    <!-- 赤血球数 -->
    <input-num
      v-model.number="RED_BLC"
      :title="`${$t('bloodTestResult.redBloodCells')}(任意)`"
      unit="10^4/μL"
      name="redBloodCells"
      min="0"
      max="999"
      v-validate="'between: 0, 999'"
      data-vv-as="赤血球数"
    />
    <div class="invalid" v-show="errors.has('redBloodCells')">
      {{ $t("validation.between") }}
    </div>
    <!-- 血小板数 -->
    <input-num
      v-model.number="PLT_CNT"
      :title="`${$t('bloodTestResult.plateletCount')}(任意)`"
      unit="10^4/μL"
      min="0"
      max="99"
      v-validate="'between: 0, 99'"
      name="plateletCount"
      data-vv-as="血小板数"
    />
    <div class="invalid" v-show="errors.has('plateletCount')">
      {{ $t("validation.between") }}
    </div>
    <!-- ヘマトクリット -->
    <input-num
      v-model.number="HEMATOCRIT"
      :title="`${$t('bloodTestResult.hematocrit')}(任意)`"
      unit="%"
      min="0.0"
      max="100.0"
      v-validate="'between:0.0,100.0'"
      name="hematocrit"
      data-vv-as="ヘマトクリット"
    />
    <div class="invalid" v-show="errors.has('hematocrit')">
      {{ $t("validation.between") }}
    </div>

    <heading :title="$t('bloodTestResult.liverTitle')" class="heading" />
    <!-- ガンマGTP -->
    <input-num
      v-model.number="GAMMA_GTP"
      :title="$t('bloodTestResult.γGtp')"
      unit="U/L"
      name="gamma-gtp"
      v-validate="'required|between: 0.0, 1000.0'"
      :class="{ invalid: errors.has('gamma-gtp') }"
      data-vv-as="ガンマ-GTP"
    />
    <div class="invalid" v-show="errors.has('gamma-gtp')">
      {{ errors.first("gamma-gtp") }}
    </div>
    <!-- AST -->
    <input-num
      v-model.number="SGOT_AST"
      title="AST(GOT)"
      unit="U/L"
      name="ast"
      v-validate="'required|between: 0.0, 1000.0'"
      :class="{ invalid: errors.has('ast') }"
      data-vv-as="AST(GOT)"
    />
    <div class="invalid" v-show="errors.has('ast')">
      {{ errors.first("ast") }}
    </div>
    <!-- ALT -->
    <input-num
      v-model.number="SGPT_ALT"
      title="ALT(GPT)"
      unit="U/L"
      name="sgpt-alt"
      v-validate="'required|between: 0.0, 1000.0'"
      :class="{ invalid: errors.has('sgpt-alt') }"
      data-vv-as="ALT(GPT)"
    />
    <div class="invalid" v-show="errors.has('sgpt-alt')">
      {{ errors.first("sgpt-alt") }}
    </div>

    <heading :title="$t('bloodTestResult.urinaryTest')" class="heading" />
    <!-- 尿タンパク -->
    <div class="input-field orig-prote-field">
      <label
        for="orig_prote_cd"
        class="orig-label"
        　　:class="{ invalid: errors.has('orig_prote_cd') }"
        >{{ $t("bloodTestResult.urinaryProtein") }}</label
      >
      <select
        id="orig_prote_cd"
        v-model.number="OLIG_PROTE_CD"
        name="orig_prote_cd"
        v-validate="'required|between: 1, 6'"
        :class="{ invalid: errors.has('orig_prote_cd') }"
        data-vv-as="尿タンパク"
      >
        <option value="0">{{ $t("bloodTestResult.noInput") }}</option>
        <option value="1">{{ $t("bloodTestResult.negative") }}</option>
        <option value="2">{{ $t("bloodTestResult.trace") }}</option>
        <option value="3">{{ $t("bloodTestResult.+1") }}</option>
        <option value="4">{{ $t("bloodTestResult.+2") }}</option>
        <option value="5">{{ $t("bloodTestResult.+3") }}</option>
        <option value="6">{{ $t("bloodTestResult.+4") }}</option>
      </select>
    </div>
    <div class="invalid" v-show="errors.has('orig_prote_cd')">
      {{ $t("validation.requiredText") }}
    </div>
    <!-- クレアチニン(必須項目) -->
    <input-num
      v-model.number="CREATININE"
      :title="$t('bloodTestResult.serumCreatinine')"
      unit="md/dl"
      v-validate="'required|between: 0.0, 99.9'"
      name="creatinine"
      :class="{ invalid: errors.has('creatinine') }"
      data-vv-as="血清クレアチニン"
    />
    <div class="invalid" v-show="errors.has('creatinine')">
      {{ errors.first("creatinine") }}
    </div>
    <!-- 尿酸 -->
    <input-num
      v-model.number="URIC_ACID"
      :title="`${$t('bloodTestResult.urinaryAcid')}(任意)`"
      unit="mg/dL"
      name="urinaryAcid"
      min="0.0"
      max="99.9"
      v-validate="'between: 0.0, 99.9'"
      data-vv-as="尿酸"
    />
    <div class="invalid" v-show="errors.has('urinaryAcid')">
      {{ $t("validation.between") }}
    </div>
    <!-- 尿糖 -->
    <div class="input-field orig-prote-field">
      <label for="uricSugar" class="orig-label">{{
        `${$t("bloodTestResult.urinarySugar")}(任意)`
      }}</label>
      <select v-model.number="URIC_SUGAR" name="uricSugar">
        <option value="1">{{ $t("bloodTestResult.noInput") }}</option>
        <option value="2">{{ $t("bloodTestResult.negative") }}</option>
        <option value="3">{{ $t("bloodTestResult.trace") }}</option>
        <option value="4">{{ $t("bloodTestResult.+1") }}</option>
        <option value="5">{{ $t("bloodTestResult.+2") }}</option>
        <option value="6">{{ $t("bloodTestResult.+3") }}</option>
        <option value="7">{{ $t("bloodTestResult.+4") }}</option>
      </select>
    </div>

    <next-button
      :label="$t('common.next')"
      :disabled="isDisable"
      @click="clickNextButton"
      class="next-button"
    />
  </div>
</template>

<script>
import Heading from "../../components/atoms/Heading";
import InputNum from "../../components/molecules/AiDiseasePrediction/InputNum";
import NextButton from "../../components/atoms/NextButton";

export default {
  components: {
    Heading,
    InputNum,
    NextButton,
  },
  data() {
    return {
      // 各項目に値が入力されているかどうか確認
      bldsValue: {
        value: null,
      },
      totalCholesterol: {
        value: null,
      },
    };
  },
  computed: {
    BLDS: {
      set(val) {
        this.$store.dispatch("aiPrediction/setBLDS", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getBLDS"];
      },
    },
    // HbA1c
    HBA1C: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHBA1C", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHBA1C"];
      },
    },
    TOT_CHOLE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setTOT_CHOLE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getTOT_CHOLE"];
      },
    },
    TRIGLYCERIDE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setTRIGLYCERIDE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getTRIGLYCERIDE"];
      },
    },
    HDL_CHOLE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHDL_CHOLE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHDL_CHOLE"];
      },
    },
    LDL_CHOLE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setLDL_CHOLE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getLDL_CHOLE"];
      },
    },
    HMG: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHMG", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHMG"];
      },
    },
    // 白血球数
    WHITE_BLC: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWHITE_BLC", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWHITE_BLC"];
      },
    },
    // 赤血球数
    RED_BLC: {
      set(val) {
        this.$store.dispatch("aiPrediction/setRED_BLC", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getRED_BLC"];
      },
    },
    // 血小板数
    PLT_CNT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setPLT_CNT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getPLT_CNT"];
      },
    },
    // ヘマトクリット
    HEMATOCRIT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHEMATOCRIT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHEMATOCRIT"];
      },
    },
    CREATININE: {
      set(val) {
        this.$store.dispatch("aiPrediction/setCREATININE", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getCREATININE"];
      },
    },
    GAMMA_GTP: {
      set(val) {
        this.$store.dispatch("aiPrediction/setGAMMA_GTP", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getGAMMA_GTP"];
      },
    },
    SGOT_AST: {
      set(val) {
        this.$store.dispatch("aiPrediction/setSGOT_AST", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getSGOT_AST"];
      },
    },
    SGPT_ALT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setSGPT_ALT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getSGPT_ALT"];
      },
    },
    OLIG_PROTE_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setOLIG_PROTE_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getOLIG_PROTE_CD"];
      },
    },
    // 尿酸
    URIC_ACID: {
      set(val) {
        this.$store.dispatch("aiPrediction/setURIC_ACID", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getURIC_ACID"];
      },
    },
    // 尿糖
    URIC_SUGAR: {
      set(val) {
        this.$store.dispatch("aiPrediction/setURIC_SUGAR", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getURIC_SUGAR"];
        if (value === null) {
          // 非選択時
          this.$store.dispatch("aiPrediction/setURIC_SUGAR", 1);
          return this.$store.getters["aiPrediction/getURIC_SUGAR"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    isDisable() {
      let bool = Object.keys(this.fields).some(
        (key) => this.fields[key].invalid
      );
      this.$store.dispatch("validations/setBloodTestResult", bool);
      return bool;
    },
  },
  methods: {
    clickNextButton() {
      this.$emit("increment");
    },
  },
  created() {
    // スクロールの位置を初期化； indexをページトップにする処理
    scrollTo(0, 0);
  },
};
</script>

<style scoped>
.input-filed--container {
  width: 100%;
  margin: auto;
}

.input-field > select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.input-field > select {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  background-color: #ffffff;
  height: 40px;
  font-size: calc(100% + 0.25vw);
}
.heading {
  margin-top: 20px;
}
.orig-prote-field {
  display: grid;
  grid-template-columns: 2fr 6fr;
  align-items: center;
  margin-top: 20px;
  gap: 20px;
}
@media screen and (max-width: 599px) {
  .orig-prote-field {
    grid-template-columns: 1fr 1fr;
  }
}
.orig-label {
  justify-self: start;
  padding-left: 20px;
}
.next-button {
  margin-top: 40px;
}
.invalid {
  border-color: red;
  color: red;
  margin-top: 10px;
}
.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(100% + 0.25vw);
}
/*validation error 発生領域表示*/
.form-control.error {
  border-color: #e84444;
}
/*正常系*/
.form-control.pass {
  border-color: blue;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(232, 68, 68, 0.6);
}
</style>
